import { render, staticRenderFns } from "./user-profile-dialog.vue?vue&type=template&id=5a84a0f4"
import script from "./user-profile-dialog.vue?vue&type=script&lang=js"
export * from "./user-profile-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports